<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="权限">
        <a-input
          v-model:value="formState.name"
          placeholder="输入检索权限"
          allow-clear
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handelSearch">检索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="showAddModal">添加权限</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑权限' : '添加权限'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-perm
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
      ></add-perm>
    </a-modal>
    <a-tree
      block-node
      :tree-data="showTree"
      :fieldNames="{ title: 'name', key: 'permission_id' }"
      defaultExpandAll
      v-if="showTree?.length"
    >
      <template #title="{ name, permission_id }">
        <div>
          {{ name }}
          <span class="utils">
            <a-button
              type="primary"
              shape="circle"
              size="small"
              title="添加子权限"
              @click="showAddModal(permission_id, tableData)"
            >
              <PlusOutlined />
            </a-button>
            &nbsp;
            <a-button
              type="primary"
              shape="circle"
              size="small"
              title="编辑权限"
              @click="showEditModal(permission_id, tableData)"
            >
              <EditOutlined />
            </a-button>
            &nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(permission_id)"
            >
              <a-button
                type="primary"
                danger
                shape="circle"
                size="small"
                title="删除权限"
              >
                <DeleteOutlined />
              </a-button>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-tree>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { getPerm, deletePerm } from '@/api/system_manage/perm'
  import { buildTree, searchTree } from '@/utils/tree'
  import AddPerm from './addPerm'
  import { message } from 'ant-design-vue'
  import {
    EditOutlined,
    PlusOutlined,
    DeleteOutlined,
  } from '@ant-design/icons-vue'

  //1、检索
  const formState = reactive({
    name: '',
  })
  function handelSearch() {
    showTree.value = searchTree('name', formState.name, treeData.value)
  }

  //2、树结构
  const tableData = ref([])
  const treeData = ref([])
  const showTree = ref([])
  function fetch() {
    getPerm({
      ...formState,
    }).then(({ data }) => {
      const tree = buildTree(data, { idName: 'permission_id' })
      tableData.value = data
      treeData.value = tree
      showTree.value = tree
    })
  }
  onMounted(fetch)

  //3、新增/编辑
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)
  const showAddModal = (id, data) => {
    editData.value = data
      ? data.find((item) => item.permission_id === id)
      : null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (id, data) => {
    editData.value = data.find((item) => item.permission_id === id)
    isEdit.value = true
    open.value = true
  }
  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  //4、删除
  async function delRow(id) {
    const res = await deletePerm({ permissionId: id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
<style lang="less" scoped>
  .utils {
    display: none;
    .anticon {
      margin: 0 !important;
    }
  }
  .ant-tree-treenode:hover {
    .utils {
      display: inline-block;
    }
  }
</style>
